import React, { type HTMLAttributes } from 'react';
import CountUp from 'react-countup';
import c from 'classnames';

import {
  Icon,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphMetricItem as Type } from '../../../types/uncinc_profile/paragraphs';
import { ButtonWrapper } from '../../../components';

import './style.scss';

interface ParagraphMetricItemProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphMetricItem: React.FC<ParagraphMetricItemProps> = ({
  entity,
}) => {
  const paragraph = entity.toJS();

  const { icon, family: flair } = paragraph.field_icon[0] || {};
  const colorClass = paragraph.field_labels[0]?.entity.field_icon[0]?.classes ?? 'u-background--secondary--600';
  const body = paragraph.field_body[0]?.processed;
  const number = paragraph.field_value[0].value;
  const suffix = paragraph.field_suffix[0]?.value;
  const prefix = paragraph.field_prefix[0]?.value;
  const unit = paragraph.field_unit[0]?.value;
  const link = paragraph.field_link[0];
  const linkUrl = link?.alias ?? link?.uri;
  const linkTitle = link?.title;

  const decimals = String(number).split('.');

  return (
    <div className={c('ParagraphMetricItem', colorClass)}>
      {icon && (
        <div className="ParagraphMetricItem__icon">
          <Icon name={icon} flair={flair === 'baseline' ? 'filled' : flair} />
        </div>
      )}
      <div className="ParagraphMetricItem__wrapper">
        <div className="ParagraphMetricItem__number">
          {prefix && <span className="ParagraphMetricItem__number__prefix">{prefix}</span>}
          <CountUp
            end={number}
            decimals={decimals[1] ? decimals[1].length : 0}
            decimal=","
            separator="."
            duration={4}
            enableScrollSpy
            scrollSpyOnce
            scrollSpyDelay={300}
          />
          {suffix && <span className="ParagraphMetricItem__number__suffix">{suffix}</span>}
          {unit && <span className="ParagraphMetricItem__number__unit">{unit}</span>}
        </div>
        {body && (
          <div className="ParagraphMetricItem__body">
            <WysiwygField html={body} />
          </div>
        )}
        {linkUrl && linkTitle && (
          <ButtonWrapper
            href={linkUrl}
            className="ParagraphMetricItem__link"
            type="textual"
            inverted={colorClass.startsWith('u-background--secondary')}
          >
            {linkTitle}
          </ButtonWrapper>
        )}
      </div>
    </div>
  );
};

export default ParagraphMetricItem;
